// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__9Lft1","icon":"SortAdornment_icon__3GEK0","up":"SortAdornment_up__mX81c","down":"SortAdornment_down__b15R0","active":"SortAdornment_active__15u24"};